import React from 'react';
import {Row, Button, Select, DatePicker, Form} from 'antd';
import config from '../../../config';
import { getCustomerBase } from '../../../services/serviceReports';

const {RangePicker} = DatePicker;
const requiredField = {required: true, message: 'Bu Alan Zorunludur'};

const CustomerReportBaseFilters = ({customers, updateHandler}) => {
    

    const onSubmit = (formData) => {
        const {customer, dateRange: [startDate, endDate]} = formData;
        getCustomerBase({customerId: customer, startDate, endDate})
            .then(({data}) => {
                if(data) {
                    updateHandler({
                        customerId: customer,
                        startDate,
                        endDate,
                        data
                    })
                }
            })
    };

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    }

    return(
        <React.Fragment>
            <Row>
                <Form
                    layout='inline'
                    onFinish={onSubmit}
                >   
                    <Form.Item name={'customer'} rules={[requiredField]}>
                        <Select style={{minWidth: '150px'}} options={customers} showSearch placeholder={'Lütfen Müşteri Seçiniz'} allowClear filterOption={selectSearch} />
                    </Form.Item>
                    <Form.Item name={'dateRange'} rules={[requiredField]}>
                        <RangePicker  allowClear format={config.userDateFormat}/>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType='submit' type={'primary'} block={true}>Filtrele</Button>
                    </Form.Item>
                </Form>
            </Row>
        </React.Fragment>
    )
}

export default CustomerReportBaseFilters;